import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { NotificationAction, NotificationReducer } from 'types/notification'
import NotificationActions from 'actions/Notification'
import { Dispatch } from 'redux'
import {
    MainForm,
    TopInputs,
    ContainerForm,
    Content,

} from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/AccountabilityMatrix/styles'

import { useForm } from 'react-hook-form'
import NotificationService from 'services/Notification'
import { BackButton, SaveButton } from './styles'
import { AccountabilityMatrixQuestionFlow } from './AccountabilityMatrixQuestionFlow'
import { useCallbackPrompt } from 'hooks/useCallbackPrompt'

import { Beforeunload } from 'react-beforeunload'

import LeftSideV2 from 'pages/Notifications/LeftSideV2'
import { IconWarning } from 'components/NavBar/svg'
import { SubTitleText, TitleText } from 'pages/NotifyEvent/styles'
import { Confirm } from 'components/Modals/Confirm'
import { WarningModal } from 'components/Modals/WarningModal'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { Breadcrumbs, SecondTextBreadcrumbs } from '../Header/styles'
import { Link } from 'react-router-dom'

/**
/**
 * Formulário principal para edição das informações do diagrama de ishikawa
 */
const FormAccountabilityMatrix: React.FC = () => {
    const [question01, setQuestion01] = useState('')
    const [question02, setQuestion02] = useState('')
    const [question03, setQuestion03] = useState('')
    const [question04, setQuestion04] = useState('')
    const [question05, setQuestion05] = useState('')
    const [question06, setQuestion06] = useState('')
    const [question07, setQuestion07] = useState('')
    const [question08, setQuestion08] = useState('')
    const [question09, setQuestion09] = useState('')
    const [question10, setQuestion10] = useState('')
    const [result, setResult] = useState('')

    const [changeQuestions, setChangeQuestions] = useState<boolean>(false)
    const [warningModal, setWarningModal] = useState<boolean>(false)
    const [isDirty, setIsDirty] = useState<boolean>(false)

    const MSG_SUCCESS = `Matriz de responsabilização salva com sucesso!`

    const { handleSubmit } = useForm();

    const [notificationStatusState, setNotificationStatusState] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const notificationSelector: NotificationReducer = useSelector((state: RootReducerState) => state.notificationsReducer)
    const notificationDispatch: Dispatch<NotificationAction> = useDispatch()

    const { id } = useParams()
    const navigate = useNavigate()

    const accountabilityMatrixMemo = useMemo(() => {
        if (notificationSelector?.accountabilityMatrix) {
            return notificationSelector?.accountabilityMatrix[0]
        }
    }, [notificationSelector?.accountabilityMatrix])

    useEffect(() => {
        setQuestion01(accountabilityMatrixMemo?.u_question_01)
        setQuestion02(accountabilityMatrixMemo?.u_question_02)
        setQuestion03(accountabilityMatrixMemo?.u_question_03)
        setQuestion04(accountabilityMatrixMemo?.u_question_04)
        setQuestion05(accountabilityMatrixMemo?.u_question_05)
        setQuestion06(accountabilityMatrixMemo?.u_question_06)
        setQuestion07(accountabilityMatrixMemo?.u_question_07)
        setQuestion08(accountabilityMatrixMemo?.u_question_08)
        setQuestion09(accountabilityMatrixMemo?.u_question_09)
        setQuestion10(accountabilityMatrixMemo?.u_question_10)
        setResult(accountabilityMatrixMemo?.u_matrix_result)

    }, [accountabilityMatrixMemo])

    const [notificationsList, setNotificationsList] = useState<any>([])

    useEffect(() => {
        /* @TODO: US-66215 - Optimização de multiplos requests

        NotificationActions.getNotificationById(notificationDispatch, id)
        NotificationActions.getAccountabilityMatrixByNotificationId(notificationDispatch, id)
        */
    }, [])

    const backToAccountabilityMatrix = useCallback((e: any) => {
        navigate(`/notificacoes/${id}`, { state: { currentStep: 4 } })
    }, [])

    useEffect(() => {
        if (notificationSelector?.notificationById?.u_state) {
            setNotificationStatusState(notificationSelector?.notificationById?.u_state.display_value)
        }
    }, [notificationSelector.notificationById])


    const handleSubmitForm = () => {
        setIsDirty(false)
        setIsSaving(true)
        let AccountabilityMatrixSN: any = {
            ...(accountabilityMatrixMemo?.sys_id ? { sys_id: accountabilityMatrixMemo?.sys_id } : {}),
            u_hospital_incident: id,
            u_do_not_perform_optional: "false",
            u_question_01: question01,
            u_question_02: question02,
            u_question_03: question03,
            u_question_04: question04,
            u_question_05: question05,
            u_question_06: question06,
            u_question_07: question07,
            u_question_08: question08,
            u_question_09: question09,
            u_question_10: question10,
            u_matrix_result: result
        }

        NotificationService.saveAccountabilityMatrix(AccountabilityMatrixSN)
            .then(() => {
                navigate(`/notificacoes/${id}`, { state: { currentStep: 4, messageSuccess: MSG_SUCCESS } })
            }).catch((error) => {
                console.log("saveAccountabilityMatrix error", error)
            })
    }

    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(isDirty && !isSaving)

    const handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        setIsDirty(false)
        setResult('')

        if (name === "u_question_01") {
            setIsDirty(false)
            setQuestion01(value)
            setQuestion02("")
            setQuestion03("")
            setQuestion04("")
            setQuestion05("")
            setQuestion06("")
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
        } else if (name === "u_question_02") {
            setQuestion02(value)
            setQuestion03("")
            setQuestion04("")
            setQuestion05("")
            setQuestion06("")
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
            setIsDirty(value === "yes")
        } else if (name === "u_question_03") {
            setQuestion03(value)
            setQuestion04("")
            setQuestion05("")
            setQuestion06("")
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
            setIsDirty(false)
        } else if (name === "u_question_04") {
            setQuestion04(value)
            setIsDirty(value === "no")
            setQuestion05("")
            setQuestion06("")
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
        } else if (name === "u_question_05") {
            setQuestion05(value)
            setQuestion06("")
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
            setIsDirty(false)
        } else if (name === "u_question_06") {
            setQuestion06(value)
            setQuestion07("")
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
            setIsDirty(false)
        } else if (name === "u_question_07") {
            setQuestion07(value)
            setIsDirty(true)
            setQuestion08("")
            setQuestion09("")
            setQuestion10("")
        } else if (name === "u_question_08") {
            setQuestion08(value)
            setQuestion09("")
            setQuestion10("")
            setIsDirty(false)
        } else if (name === "u_question_09") {
            setQuestion09(value)
            setIsDirty(true)
            if (question08 === "no") {
                setQuestion10("")
            }
        } else if (name === "u_question_10") {
            if (value === "yes") {
                setQuestion09("")
            } else {
                setIsDirty(true)
            }
            setQuestion10(value)
        }
    }

    useEffect(() => {
        if (accountabilityMatrixMemo && accountabilityMatrixMemo?.u_matrix_result !== "") {
            let changeQuestions = accountabilityMatrixMemo?.u_question_02 !== question02 ||
                accountabilityMatrixMemo?.u_question_04 !== question04 ||
                accountabilityMatrixMemo?.u_question_07 !== question07 ||
                accountabilityMatrixMemo?.u_question_09 !== question09 ||
                accountabilityMatrixMemo?.u_question_10 !== question10;
            setChangeQuestions(changeQuestions)
        }
    }, [question02, question04, question07, question09, question10])

    useEffect(() => {
        let AccountabilityMatrixSN: any = {
            u_question_01: question01,
            u_question_02: question02,
            u_question_03: question03,
            u_question_04: question04,
            u_question_05: question05,
            u_question_06: question06,
            u_question_07: question07,
            u_question_08: question08,
            u_question_09: question09,
            u_question_10: question10,
        }
        if (isDirty) {
            NotificationActions.getResultAccountabilityMatrix(notificationDispatch, AccountabilityMatrixSN)
                .then((res) => {
                    setResult(res.data.result)
                }).catch((e: any) => {
                    console.log("Ocorreu um erro ao calcular a preview do resultado da matrix", e)
                }).finally(() => {
                    setIsSaving(false)
                })

        }

    }, [question02, question04, question07, question09, question10])

    return (
        <>
            {isDirty && (
                <Beforeunload onBeforeunload={(event) => 'Você fez edições que não forma salvas.'} />
            )}
            <Confirm
                isOpen={showPrompt as boolean}
                handleConfirmModal={confirmNavigation as any}
                handleCloseModal={cancelNavigation as any}
                labelButtomClose={`Sair`}
                labelButtomConfirm={`Continuar edição`}
            >
                <div className='justify-center flex p-1'>
                    <IconWarning></IconWarning>
                </div>
                <TitleText className={'text-yellow text-xl font-semibold justify-center flex'}>
                    Edição não salva
                </TitleText>
                <div className='justify-center flex'>
                    <SubTitleText >
                        <p>Você fez edições que não foram salvas.</p>
                        <p>Se sair, você perderá as edições.</p>
                    </SubTitleText>
                </div>
            </Confirm>

            <WarningModal
                icon={<AiOutlineExclamationCircle size={50} className="text-yellow" />}
                customStyle={{ titleStyle: 'text-yellow' }}
                title="Alterar resposta"
                isOpen={warningModal as boolean}
                subTitle="O fluxo será atualizado e todas as respostas anteriormente salvas serão perdidas."
                leftButtonText="Cancelar"
                leftButtonAction={() => setWarningModal(false)}
                handleCloseModal={() => setWarningModal(false)}
                rightButtonText="Alterar resposta"
                rightButtonAction={() => handleSubmitForm()}
            />

            <ContainerForm>
                <MainForm onSubmit={handleSubmit(handleSubmitForm)}>
                    <div className='flex items-baseline mt-8 justify-between'>
                        <Breadcrumbs>
                            <Link className="mr-1 cursor-pointer" to="/notificacoes">
                                Gestão das notificações
                            </Link>
                            {' > '}
                            <SecondTextBreadcrumbs className="mr-1 cursor-pointer" onClick={backToAccountabilityMatrix}>
                                Notificações
                            </SecondTextBreadcrumbs>
                            {' > '}
                            <SecondTextBreadcrumbs>Matriz de responsabilização</SecondTextBreadcrumbs>
                        </Breadcrumbs>
                          
                        <TopInputs>
                            <BackButton type='button' onClick={backToAccountabilityMatrix}>Voltar</BackButton>
                            {changeQuestions ?
                                (<SaveButton type='button' onClick={() => setWarningModal(true)} disabled={!isDirty} className={!isDirty ? 'bg-disabled' : ''}>
                                    Salvar
                                </SaveButton>) :
                                (<SaveButton type='submit' disabled={!isDirty} className={!isDirty ? 'bg-disabled' : ''}>
                                    Salvar
                                </SaveButton>)}
                        </TopInputs>
                                        
                    </div>
             
                    <Content>
                        <div className='flex flex-col col-span-2 min-w-0'>
                            <div className='container min-w-0 max-w-full'>
                                <AccountabilityMatrixQuestionFlow
                                    variant="individual"
                                    question01={question01}
                                    question02={question02}
                                    question03={question03}
                                    question04={question04}
                                    question05={question05}
                                    question06={question06}
                                    question07={question07}
                                    question08={question08}
                                    question09={question09}
                                    question10={question10}
                                    result={result}
                                    handleChange={handleChange}
                                />
                            </div>
                        </div>
                        <LeftSideV2
                            isShowAnalyze={false}
                            currentNotificationSelected={notificationSelector.notificationById}
                            notificationsList={notificationsList}
                            setNotificationsList={setNotificationsList} 
                            handleShowGroupTreatmentModal={undefined} 
                            userProfile={undefined}                        />
                    </Content>
                </MainForm>
            </ContainerForm>
        </>
    )
}

export { FormAccountabilityMatrix as FormAccountabilityMatrix }
